export default __webpack_public_path__ + "static/media/28-lock-up-tight.6a6ec129.jpg";